module.exports = "/assets/images/zastrcka.9c706565.svg";